import { LinearProgress } from "@mui/material"
import { linearProgressClasses } from "@mui/material/LinearProgress"
import { styled } from "@mui/material/styles"

const AppProgressBar = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor:
            theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.primary,
    },
}))

export default AppProgressBar
